import React from "react";
import { Form } from "react-final-form";
import Updater from "./Updater";
import { ErrorContext } from "./MutationForm";
import { ValueContext } from "./ValueContext";
import { Decorator } from "final-form";

type NotifierFormProps<TValues> = {
  values: TValues;
  onChange: React.Dispatch<TValues>;
  children: React.ReactNode;
  decorators?: Decorator<any, Record<string, any>>[];
};

export const NotifierForm = <TValues,>(
  props: NotifierFormProps<TValues>
): React.ReactElement => {
  const { values, onChange, children } = props;

  return (
    <Form
      onSubmit={() => undefined}
      initialValues={values as any}
      decorators={props.decorators}
      render={({ handleSubmit, values, error, submitError }) => {
        return (
          <form onSubmit={handleSubmit}>
            <ErrorContext.Provider value={submitError || error || ""}>
              <ValueContext.Provider value={values}>
                {children}
              </ValueContext.Provider>
            </ErrorContext.Provider>
            <Updater value={values} callback={onChange} />
          </form>
        );
      }}
    />
  );
};
